/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import Input from 'components/inputs/Input/Input';
import Button2 from 'components/buttons/Button2/Button2';
import { ReactComponent as ArrowTopRight } from 'assets/icons/arrow-top-right.svg';
import withTitle from 'hocs/WithTitle';
import styles from './style.cssmodule.css';
import { useSignIn } from './useSignIn';

const SignIn = ({
  handleFormTypeChange,
}) => {
  const { formatMessage: t } = useIntl();

  const {
    fields,
    changeField,
    errors,
    isSubmitting,
    handleSubmit,
  } = useSignIn();

  return (
    <form>
      <div className={styles.inputGrid}>
        <Input
          label={t({ id: 'field.emailExplicitConnexion' })}
          type="email"
          name="email"
          autoComplete="email"
          disabled={isSubmitting}
          value={fields.email}
          error={errors.email}
          onChange={({ target: { value: newEmail } }) => changeField({ name: 'email', value: newEmail })}
        />
        <div>
          <Input
            label={t({ id: 'field.password' })}
            type="password"
            name="password"
            autoComplete="current-password"
            disabled={isSubmitting}
            value={fields.password}
            error={errors.password}
            onChange={({ target: { value: newPassword } }) => changeField({ name: 'password', value: newPassword })}
          />
          <div className={styles.forgottenPassword}>
            <span>
              {t({ id: 'info.forgotPasswordLong' })}
            </span>
            {' '}
            <span className={styles.resetLink} onClick={() => handleFormTypeChange('forgotPassword')}>
              {t({ id: 'info.resetPassword' })}
            </span>
          </div>
        </div>
      </div>
      <Button2
        onClick={handleSubmit}
        loading={isSubmitting}
        disabled={isSubmitting}
        type="primary"
        className={styles.signInButton}
        size="medium"
      >
        {t({ id: 'button.signIn' })}
        <ArrowTopRight />
      </Button2>
    </form>
  );
};

SignIn.propTypes = {
  handleFormTypeChange: PropTypes.func,
};

SignIn.defaultProps = {
  handleFormTypeChange: () => {},
};

module.exports = withTitle('pageTitle.login')(SignIn);



// WEBPACK FOOTER //
// ./routes/login/components/cpm_client/components/SignIn/SignIn.jsx